module.exports = __webpack_public_path__ + "static/media/wordmark_white.0e0f76f3.svg";